






























































































































































import { Component, Vue } from 'vue-property-decorator';
import { api } from '@/api';
import { appName } from '@/env';
import { readLoginError } from '@/store/main/getters';
import {dispatchLogIn, dispatchRegister} from '@/store/main/actions';
// @ts-ignore
import backgroundImg from '@/assets/images/bg-2.jpg';
// @ts-ignore
import backgroundImgX2 from '@/assets/images/bg-2.jpg';
import {FmvAvatar} from 'fmv-avatar';
import {FmvInputGroupMerge} from 'fmv-input-group-merge';

@Component({
  components: {
    FmvAvatar,
    FmvInputGroupMerge,
  },
})
export default class Register extends Vue {
  public name: string = '';
  public email: string = '';
  public password: string = '';
  public phone: string = '';
  public phonePayload: any = {
    countryCode: '',
    formattedNumber: '',
  };
  public nameError: boolean = false;
  public emailError: boolean = false;
  public emailTakenError: boolean = false;
  public passwordError: boolean = false;
  public phoneError: any = {
    value: false,
    hint: '',
  };
  public promo: string = '';
  public promoLink: string = '';
  public brand: string = 'unifordi';
  public logoPath: string = '@/assets/images/logo.svg';
  public linkComponent: string = 'b-link';
  public subtitle: string = '';
  public appName = appName;
  public backgroundImage = backgroundImg;
  public backgroundImageX2 = backgroundImgX2;
  public loadingState: any = {
    submit: false,
  };

  public async mounted() {
    this.promoLink = this.$router.currentRoute.params.promo ? this.$router.currentRoute.params.promo : '';
    this.subtitle = this.promoLink ? `${this.$t('Referral promo code')}: ${this.promoLink}` : '';
  }

  public get loginError() {
    return readLoginError(this.$store);
  }

  public async submit() {
    this.loadingState.submit = true;
    let valid = true;
    if (this.name === '') {
      this.nameError = true;
      valid = false;
    } else {
      this.nameError = false;
    }
    if (this.emailTakenError || this.email === '' || (this.email && !/(.+)@(.+){1,}\.(.+){2,}/.test(this.email))) {
      this.emailError = true;
      valid = false;
    } else {
      this.emailError = false;
    }
    if (this.password === '') {
      this.passwordError = true;
      valid = false;
    } else {
      this.passwordError = false;
    }
    if (!this.phonePayload.formattedNumber || this.phoneError.value) {
      if (!this.phonePayload.formattedNumber) {
        this.phoneError = {
          value: true,
          hint: this.$t('This field cannot be empty'),
        };
      }
      valid = false;
    }
    if (valid) {
      await dispatchRegister(
        this.$store,
        {
          name: this.name,
          email: this.email,
          password: this.password,
          promo: this.promoLink ? this.promoLink : this.promo,
          phone: this.phonePayload.formattedNumber,
          country: this.phonePayload.countryCode,
        },
      );
    }
    this.loadingState.submit = false;
  }

  public async validatePhone(payload) {
    this.phonePayload = payload;
    if (payload.isValid) {
      const response = await api.validateUserPhone(
        {phone: payload.formattedNumber, user: null },
      );
      this.phoneError = {
        value: !response.data.valid,
        hint: !response.data.valid ? this.$t('Phone is already in use') : '',
      };
    } else if (payload.phoneNumber) {
      this.phoneError = {
        value: !payload.isValid,
        hint: !payload.isValid ? this.$t('Phone is incorrect') : '',
      };
    } else {
      this.phoneError = {
        value: false,
        hint: '',
      };
    }
  }

  public async validateEmail() {
    if (this.email) {
      const response = await api.validateUserEmail(
        {email: this.email },
      );
      this.emailTakenError = !response.data.valid;
    } else {
      this.emailTakenError = false;
    }
  }
}
